import { GetterTree } from "vuex";
import { RootState } from "@/store/types";
import { TeamState } from "../types";

const getters: GetterTree<TeamState, RootState> = {
  getAllMembers: (state) => state.members.items,
  getAllPendingMembers: (state) => state.pendingMembers,
  getCurrentTeamMember: (state) => state.currentMember,
  getCurrentPendingMember: (state) => state.currentPendingMember,
  getInviteSender: (state) => state.inviteSender,
  getSuperAdminCount: (state) => state.superAdminCount,
};

export default getters;
